export const formatCurrency = (amount, currency = 'DKK') => {
  /*
    I am doubtful about this one.
    I checked about the decimal separator and the thousand separator.
    But this can be improved.
   */
  if (typeof amount === 'number') {
    return `${currency} ${new Intl.NumberFormat('da-DK').format(amount)}`
  } else {
    return '-'
  }
}
